export default {
  incomeInput: {
		tradeBusiness: true,
		employment: true,
		consultancyFee: true,
		otherIncome: true,
		directorFee: true,
		benefitInKind: true,
		earnedBonus: true,
		terminalBonus: true,
		contract: true,
		pension: true,
		allowances: true,
		profitShare: true,
		commission: true,
		gamesAndWinnings: false,
		estateIncome: false,
		gratuity: false,
		compensationForLossOfEmployment: false,
		honoraria: false,
		prizesAndAwards: false,
		grants: false,
	},
	untaxableIncomeInput: {
		dividend: true,
		interest: true,
		annuities: false,
		royalty: true,
		rent: true,
		discounts: false,
		incomeFromSecurities: false,
		familyIncome: false,
	},
	capitalGainsInput: {
		_section: false, // This is to determine if the section should be shown or not
	},
	fiiIncome: {
		dividendAmt: true,
		interestAmt: true,
		annuitiesAmt: false,
	},
	deductionsInput: {
		pensions: true,
		gratuities: true,
		bonus: false,
		otherDeductions: true,
		incomeFromSecuritiesDeduct: false,
		compensationForLossOfEmploymentDeduct: false,
	},
	adjustmentsInput: {
		balancingCharge: true,
		balancingAllowance: true,
		losses: true,
		capitalAllowance: true
	},
	reliefsInput: {
		cra: true,
		pra: true,
		personalAllowance: true,
		nationalHealthInsuranceScheme: true,
		nationalHousingFund: true,
		childrenAllowance: true,
		dependentRelatives: true,
		lifeAssurance: true,
		nationalPensionScheme: true,
		rentRelief: false,
		others: true,
		ordinaryShareHolding: true
	},
	withheldTaxesInput: {
		whtOnRent: true,
		whtOnCommission: true,
		whtOnConsultancyService: true,
		whtOnDirectorsFee: true,
		whtOnContract: true,
		whtOnInterest: false,
		whtOthers: true
	},
	othersPrepaymentsInput: {
		doubleTaxationReliefs: true,
		commonWealthIncomeTax: true,
		overPayments: true,
		paye: true,
		prepaymentBonus: true,
		paymentOnAccount: true,
	},
}